export interface IFBTournament {
    $1: number;
    $2: number;
    $3: number;
    $4: string;
    $5: string;

    getID: () => string;
    getEndTime: () => number;
    getContextID: () => string;
}

export class FBTournamentManager {
    private static _instance: FBTournamentManager;
    private config: { title: string };
    public isTournamentActive: boolean = false;

    constructor() {
        this.config = {
            title: `Master of Donuts Tournament`,
        };
    }

    public static getInstance(): FBTournamentManager {
        if (!FBTournamentManager._instance) {
            FBTournamentManager._instance = new FBTournamentManager();
        }
        return FBTournamentManager._instance;
    }

    public async attepmtToCreateTournament(currentScore: number): Promise<void> {
        this.config.title = `Master of Dounuts Tournament`;

        return FBInstant.tournament
            .createAsync({
                initialScore: currentScore,
                data: { tournamentLevel: 'hard' },
                config: this.config,
            })
            .then(() => {
                // user successfully created tournament and switch into tournament context
                console.log('tournament succsessfully created');
            })
            .catch((e: string) => {
                console.log(e);
            });
    }

    public async getTournament(): Promise<IFBTournament> {
        let result: IFBTournament;
        await FBInstant.getTournamentAsync()
            .then((tournament: IFBTournament) => {
                if (tournament && !this.hasTournamentEnded(tournament)) {
                    result = tournament;
                }
            })
            .catch((e: string) => {
                console.log(e);
            });

        return Promise.resolve(result);

    }

    public async getRecentTournament(): Promise<IFBTournament> {
        let recentTournament: IFBTournament;

        await FBInstant.tournament
            .getTournamentsAsync()
            .then((tournaments: IFBTournament[]) => {
                if (tournaments && tournaments.length > 0) {
                    tournaments.forEach((tournament: IFBTournament) => {
                        if (!this.hasTournamentEnded(tournament)) {
                            if (!recentTournament) {
                                recentTournament = tournament;
                            } else if (recentTournament.getEndTime() > tournament.getEndTime()) {
                                recentTournament = tournament;
                            }
                        }
                    });
                }
            })
            .catch((e: string) => console.log(e));

        return Promise.resolve(recentTournament);

    }

    private postScore(score: number): Promise<void> {
        return new Promise<void>((resolve: any, reject: any): void => {
            FBInstant.tournament
                .postScoreAsync(score)
                .then(() => {
                    console.log('Tournament score has been updated');
                    resolve();
                })
                .catch((e: string) => {
                    console.log(e);
                    resolve();
                });
        });
    }

    public joinTournament(tournamentId: string): Promise<void> {
        return new Promise<void>((res: any, rej: any): void => {
            FBInstant.tournament
                .joinAsync(tournamentId.toString())
                .then(() => {
                    // Context switch completed successfully.
                    console.log('You have joined a tournament');
                    this.isTournamentActive = true;
                    res();
                })
                .catch((e: any) => {
                    console.log(e);
                    if (e.code === 'SAME_CONTEXT') {
                        this.isTournamentActive = true;
                    } else if (e.message === 'Player closed the context menu') {
                        this.isTournamentActive = false;
                    } else {
                        this.isTournamentActive = false;
                    }

                    res();
                });
        });
    }

    public shareTournament(): Promise<void> {
        return new Promise<void>((resolve: any, reject: any): void => {
            FBInstant.tournament
                .shareAsync({
                    score: 100,
                    data: { myReplayData: 'Can you beat my highscore?' },
                })
                .then( () => {
                    // continue with the game.
                    console.log('Tournament share has been successfull!');
                    resolve();
                })
                .catch((e: string) => {
                    console.log(e);
                    resolve();
                });
        });
    }

    public createTournament(score: number): Promise<void> {
        return new Promise<void>(async (resolve: any, reject: any): Promise<void> => {
            if (!FBTournamentManager.getInstance().isTournamentActive) {
                this.attepmtToCreateTournament(score).finally(() => resolve());
            } else {
                await this.postScore(score);
                this.shareTournament().finally(() => resolve());
            }
        });
    }

    private hasTournamentEnded(tournament: IFBTournament): boolean {
        const now: number = Date.now() / 1000;
        const tournamentEndDate: number = tournament.getEndTime();
        return now > tournamentEndDate;
    }
}